<template>
  <span
    class="ec-badge"
    :class="[
      `ec-badge--${variant || 'secondary'}`,
      { 'ec-badge--pill': pill },
      size ? `ec-badge--${size}` : '',
    ]"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: 'EcBadge',
  props: {
    variant: { type: String, default: 'secondary' },
    size: { type: String, default: '' },
    pill: { type: Boolean, default: false },
  },
}
</script>
